import Resource from 'Resources/Resource';
import Client, { ClientAddress, ClientAddressType, RawClient } from './Model/Client';
import parseClient from './parsers/client';
import { Metadata } from 'App/babel/resources/ResourceTyped';
import { STYLE } from 'Store/reducers/SystemNotificationReducer';

class ClientResource extends Resource {
	parse: (client: RawClient) => Client;
	eventName: string = 'account';
	constructor() {
		super('accounts', null, {
			notificationTitle: 'default.client'
		});

		this.eventName = 'account';

		this.parse = parseClient;

		// @ts-expect-error
		this.notifications.unassign = () => ({
			title: 'saved.unassigned',
			body: 'saved.unassignedDescription',
			style: STYLE.SUCCESS,
			icon: 'check'
		});

		// A company with many contacts is deleted by a worker job: the API answers 202 with metadata.queued.
		const deleted = this.notifications.delete!;
		this.notifications.delete = (data?: { metadata?: { queued?: boolean } }) =>
			data?.metadata?.queued ? { ...deleted(), body: 'deleted.accountQueued' } : deleted();
	}

	new(): Partial<Client> &
		Pick<
			Client,
			'name' | 'active' | 'userEditable' | 'categories' | 'addresses' | 'custom' | 'users' | 'projects'
		> {
		return {
			name: '',
			active: 1,
			userEditable: true,
			projects: [],
			categories: [],
			addresses: [],
			users: [],
			custom: []
		};
	}

	newAddress(type: keyof typeof ClientAddressType): ClientAddress {
		return {
			zipcode: '',
			city: '',
			state: '',
			address: '',
			type,
			country: '',
			latitude: null,
			longitude: null
		};
	}

	async find(filters?: { [key: string]: any }): Promise<{
		data: Client[];
		metadata: Metadata;
	}> {
		// Users are needed to calculate createRigths
		if (filters?.f && !filters.f.includes('users')) {
			filters.f.push('users');
		}
		return super.find(filters);
	}

	async unassign(clientId: number, userId: number): Promise<any> {
		//userId : customerID, clientID: accountID
		const assignedUrl = `/${userId}/function/assign/${clientId}`;
		this._url = '';
		const options = {
			url: assignedUrl,
			clientId,
			methodName: 'unassign'
		};
		// The success notification is fired by the base Resource via this.notifications.unassign
		// (no unassignError config — errors stay silent, as before).
		return this._deleteRequest(assignedUrl, options)
			.then(res => {
				this._triggerEvent(options, 'unassigned', res, clientId);
				return res;
			})
			.finally(() => {
				this._url = 'accounts';
			});
	}
}

const resource = new ClientResource();

export default resource;
